import { render, staticRenderFns } from "./CommonCodeManage.vue?vue&type=template&id=ff416e34&scoped=true&"
import script from "./CommonCodeManage.vue?vue&type=script&lang=js&"
export * from "./CommonCodeManage.vue?vue&type=script&lang=js&"
import style0 from "./CommonCodeManage.vue?vue&type=style&index=0&id=ff416e34&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff416e34",
  null
  
)

export default component.exports